import React, { Component } from 'react'
import Home from '../Home/Home'
import RegisterUser from '../RegisterUser/RegisterUser'
import Login from '../Login/Login'
import { Route, Switch } from "react-router-dom"

class App extends Component {
  render () {
    return (
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/panel" component={RegisterUser}/>
          <Route path="/login" component={Login}/>
        </Switch>     
    )
  }
}

export default App;
